import { render } from "./AudioExportIntroduce.vue?vue&type=template&id=753ac552&scoped=true"
import script from "./AudioExportIntroduce.vue?vue&type=script&lang=js"
export * from "./AudioExportIntroduce.vue?vue&type=script&lang=js"

import "./AudioExportIntroduce.vue?vue&type=style&index=0&id=753ac552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753ac552"]])

export default __exports__